
























import Vue from 'vue';

export default Vue.extend({
  name: 'ListItem',

  props: {
    index: {
      type: Number,
      required: true,
    },

    image: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: 'Unnamed',
    },

    description: {
      type: String,
      default: 'No details',
    },

    active: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click', this.index);
    },
  },
});
